import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import asmCrypto from "asmcrypto.js";
// npm install asmcrypto.js@0.0.11 --save

@Injectable()

export class ChatProvider {

	private aesKey: any;

	private salt = "cartaofidelidademarketplace";
	private iterations = 4096;
	private nonceLen = 12;

	constructor(public http: Http) {
		this.deriveAesKey('487dV,BE.E=t"{rc&rg%twt >V$47W+P<J*fHl7>7=/7Bq#-t%Imz *XC>-^-=},zT%>#q" %pUMpr[iFmxM "7~pJcMB>UNy-]g');
	}

	// Criar a chave AES
	private deriveAesKey(password: string) {
		this.aesKey = asmCrypto.PBKDF2_HMAC_SHA256.bytes(password, this.salt, this.iterations, 32);
	}

	private joinNonceAndData(nonce: Uint8Array, data: Uint8Array) {
		const buf = new Uint8Array(nonce.length + data.length);
		nonce.forEach((byte, i) => buf[i] = byte);
		data.forEach((byte, i) => buf[i + nonce.length] = byte);
		return buf;
	}

	private Uint8ToString(u8a){
		var CHUNK_SZ = 0x8000;
		var c = [];
		for (var i=0; i < u8a.length; i+=CHUNK_SZ) {
			c.push(String.fromCharCode.apply(null, u8a.subarray(i, i+CHUNK_SZ)));
		}
		return c.join("");
	}

	private separateNonceFromData(buf: Uint8Array) {
		const nonce = new Uint8Array(this.nonceLen);
		const data = new Uint8Array(buf.length - this.nonceLen);
		buf.forEach((byte, i) => {
			if (i < this.nonceLen) {
				nonce[i] = byte;
			} else {
				data[i - this.nonceLen] = byte;
			}
		});
		return {nonce, data};
	}

	// Retorna texto criptografado
	public encrypt(data) {
		// Número arbritario que será usado somente uma vez
		const nonce = new Uint8Array(this.nonceLen);
		asmCrypto.getRandomValues(nonce);

		const encrypted = asmCrypto.AES_GCM.encrypt(data, this.aesKey, nonce);
		return btoa(this.Uint8ToString(this.joinNonceAndData(nonce, new Uint8Array(encrypted))));
	}

	// Retorna decriptografado
	// public decrypt(buffer: Uint8Array) {
	public decrypt(b) {
		let buffer = new Uint8Array(atob(b).split("").map(function(c) { return c.charCodeAt(0); }));
		const parts = this.separateNonceFromData(buffer);
		const decrypted = asmCrypto.AES_GCM.decrypt(parts.data, this.aesKey, parts.nonce);
		const decryptedString = asmCrypto.bytes_to_string(decrypted);
		return decryptedString;
	}

}



// WEBPACK FOOTER //
// ./src/providers/chat/chat.ts